import { render, staticRenderFns } from "./GameBallRadSForm.vue?vue&type=template&id=6f6981e0"
import script from "./GameBallRadSForm.vue?vue&type=script&lang=js"
export * from "./GameBallRadSForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports